import { el } from "../utils/dom";

export type ToastKind = "success" | "error" | "info";

let region: HTMLElement | null = null;

/** Mount the single global toast region. Call once from the app shell. */
export function mountToastRegion(container: HTMLElement): HTMLElement {
  region = el("div", { className: "toast-region", role: "status", "aria-live": "polite" });
  container.append(region);
  return region;
}

export function showToast(message: string, kind: ToastKind = "info", timeoutMs = 5000): void {
  if (!region) return;

  const toast = el("div", { className: `toast toast--${kind}` }, [
    el("span", { className: "toast__message" }, [message]),
    el(
      "button",
      {
        className: "toast__close",
        "aria-label": "Dismiss",
        onclick: () => toast.remove(),
      },
      ["\u00d7"]
    ),
  ]);

  region.append(toast);

  if (timeoutMs > 0) {
    window.setTimeout(() => toast.remove(), timeoutMs);
  }
}
